import { data } from "autoprefixer";
import {
  GET_PING_MONITORS,
  GET_PING_MONITORS_SUCCESS,
  GET_PING_MONITORS_FAIL,
  GET_PING_MONITOR_DETAIL,
  GET_PING_MONITOR_DETAIL_SUCCESS,
  GET_PING_MONITOR_DETAIL_FAIL,
  ADD_PING_MONITORS,
  ADD_PING_MONITORS_FAIL,
  ADD_PING_MONITORS_SUCCESS,
  EDIT_PING_MONITORS,
  EDIT_PING_MONITORS_FAIL,
  EDIT_PING_MONITORS_SUCCESS,
  MAP_ENDPOINT_TO_SERVICE,
  MAP_ENDPOINT_TO_SERVICE_FAIL,
  MAP_ENDPOINT_TO_SERVICE_SUCCESS,
  GET_ENDPOINT_BY_SERVICE_ID,
  GET_ENDPOINT_BY_SERVICE_ID_FAIL,
  GET_ENDPOINT_BY_SERVICE_ID_SUCCESS,
  GET_TIMESTAMPS,
  GET_TIMESTAMPS_FAIL,
  GET_TIMESTAMPS_SUCCESS,
  DELETE_ENDPOINT,
  DELETE_ENDPOINT_SUCCESS,
  DELETE_ENDPOINT_FAIL,
  GET_TIMESTAMPS_BY_SERVICE_ID,
  GET_TIMESTAMPS_BY_SERVICE_ID_FAIL,
  GET_TIMESTAMPS_BY_SERVICE_ID_SUCCESS,
  GET_UPTIME_CHECK_FAILURES,
  GET_UPTIME_CHECK_FAILURES_SUCCESS,
  GET_UPTIME_CHECK_FAILURES_FAIL, VALIDATE_REGEX, VALIDATE_REGEX_FAIL, VALIDATE_REGEX_SUCCESS,
} from "./actionTypes";
import { error } from "toastr";

const INIT_STATE = {
    pingMonitors: [],
    pingMointorDetail: {},
    data: [],
    timestamps: [],
    endpointDetails: [],
    timestamps_by_service: [],
    uptimeCheckFailures: [],
    testRegex:{
      loading: false,
      valid_regex: false,
      test_string_match: false
    }
}


const PingMonitor = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PING_MONITORS_SUCCESS:
      return {
        ...state,
        pingMonitors: action.payload,
      }

    case GET_PING_MONITORS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_PING_MONITOR_DETAIL:
      return {
        ...state,
        data: action.payload
      }

    case GET_PING_MONITOR_DETAIL_SUCCESS:
      return {
        ...state,
        pingMointorDetail: action.payload,
      }

    case GET_PING_MONITOR_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_UPTIME_CHECK_FAILURES:
      return {
        ...state,
        error: null,
      };

    case GET_UPTIME_CHECK_FAILURES_SUCCESS:
      return {
        ...state,
        uptimeCheckFailures: action.payload,
      };

    case GET_UPTIME_CHECK_FAILURES_FAIL:
      return {
        ...state,
        error: action.payload,
      };


    case ADD_PING_MONITORS:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_PING_MONITORS_SUCCESS:
      return {
        ...state,
        data: action.payload
      }
    
    case ADD_PING_MONITORS_FAIL:
      return {
        ...state,
        error: action.payload
      }

    case EDIT_PING_MONITORS:
      return{
        ...state,
        error: action.payload
      }

    case EDIT_PING_MONITORS_SUCCESS:
      return{
        ...state,
        pingMointorDetail: action.payload
      }

    case EDIT_PING_MONITORS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case MAP_ENDPOINT_TO_SERVICE:
      return{
        ...state,
        error: action.payload
      }

    case MAP_ENDPOINT_TO_SERVICE_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case MAP_ENDPOINT_TO_SERVICE_SUCCESS:
      return{
        ...state,
        response: action.payload
      }

    case GET_ENDPOINT_BY_SERVICE_ID:
      return{
        ...state,
        error: action.payload
      }

    case GET_ENDPOINT_BY_SERVICE_ID_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_ENDPOINT_BY_SERVICE_ID_SUCCESS:
      return{
        ...state,
        endpointDetails: action.payload
      }

    case GET_TIMESTAMPS:
      return{
        ...state,
        error: action.payload
      }

    case GET_TIMESTAMPS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_TIMESTAMPS_SUCCESS:
      return{
        ...state,
        timestamps: action.payload
      }

    case GET_TIMESTAMPS_BY_SERVICE_ID:
      return{
        ...state,
        error: action.payload
      }

    case GET_TIMESTAMPS_BY_SERVICE_ID_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_TIMESTAMPS_BY_SERVICE_ID_SUCCESS:
      return{
        ...state,
        timestamps_by_service: action.payload
      }

    case DELETE_ENDPOINT:
      return{
        ...state
      }
    case DELETE_ENDPOINT_SUCCESS:
      return{
        ...state
      }
    case DELETE_ENDPOINT_FAIL:
      return{
        ...state,
        error: action.payload
      }
    case VALIDATE_REGEX:
      return{
        ...state,
        testRegex: {
          ...state.testRegex,
          loading: true
        }
      }
    case VALIDATE_REGEX_FAIL:
      return{
        ...state,
        testRegex: {
          ...state.testRegex,
          loading: false
        }
      }
    case VALIDATE_REGEX_SUCCESS:
      return {
        ...state,
        testRegex: {
          ...state.testRegex,
          loading: false,
          valid_regex: action.payload.valid_regex,
          test_string_match: action.payload.test_string_match,
        }
      }
    default:
      return state;
  }
}

export default PingMonitor;